import Button from 'components/Form/Button';
import { Icon, Icons } from 'components/Icon';
import React, { useState } from 'react';
import male from '../../../../../assets/male-big.png';
import Breadcrumb from 'components/Navigation/Breadcrumb';
import { useParams } from 'react-router-dom';
import { useGetGuardianDetails } from 'common/queries-and-mutations/guardian';
import { Loader } from 'components/Loader';
import { format } from 'date-fns';
import EditGuardianModal from './EditGuardianModal';
import DependantDetails from './DependantDetails';

export default function GuardiansProfile() {
  const [showEditModal, setShowEditModal] = useState(false);
  const [userId, setUserId] = useState<number | null | undefined>(null);

  const { guardianId } = useParams();

  const { data, isLoading, refetch } = useGetGuardianDetails({
    guardianId: Number(guardianId)
  });

  return (
    <div>
      {isLoading && data ? (
        <div className="mt-40 flex flex-col items-center justify-center">
          <Loader color={'#FF6606'} height={50} width={50} />
        </div>
      ) : (
        <div>
          <Breadcrumb title="Guardian Profile" />
          <div className="mt-1">
            <div className="mb-5 flex flex-row rounded bg-white">
              <div className="flex w-1/5 flex-col items-center justify-center border-r px-6">
                <div className="flex flex-col items-center justify-center gap-3">
                  <img src={male} />
                  <p className="text-xl font-bold text-[#353535]">
                    {`${data?.guardianFirstName} ${data?.guardianMiddleName} ${data?.guardianLastName}`}
                  </p>
                </div>
              </div>
              <div className="w-full">
                <div className="border-b border-[#E5E5E5]">
                  <div className="mt-3 grid grid-cols-4 gap-x-16 px-6">
                    <div className="col-span-1 px-8 py-6">
                      <p className="text-[10px] font-normal text-[#7A7C87]">
                        Name
                      </p>
                      <p className="mt-1 text-sm font-normal text-[#353535]">
                        {`${data?.guardianFirstName} ${data?.guardianMiddleName} ${data?.guardianLastName}`}
                      </p>
                    </div>
                    <div className="col-span-1 px-8 py-6">
                      <p className="text-[10px] font-normal text-[#7A7C87]">
                        Date of Birth
                      </p>
                      <p className="mt-1 text-sm font-normal text-[#353535]">
                        {data?.dateOfBirth
                          ? format(new Date(data.dateOfBirth), 'dd MMMM yyyy')
                          : 'Unknown'}
                      </p>
                    </div>
                    <div className="col-span-1 px-8 py-6">
                      <p className="text-[10px] font-normal text-[#7A7C87]">
                        Marital Status
                      </p>
                      <p className="mt-1 text-sm font-normal text-[#353535]">
                        {data?.maritalStatus}
                      </p>
                    </div>
                    <div className="col-span-1 px-8 py-6">
                      <p className="text-[10px] font-normal text-[#7A7C87]">
                        Type
                      </p>
                      <p className="mt-1 text-sm font-normal text-[#353535]">
                        {data?.guardianType}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="border-b border-[#E5E5E5]">
                  <div className="grid grid-cols-4 gap-x-16 px-6">
                    <div className="col-span-1 px-8 py-4">
                      <p className="text-[10px] font-normal text-[#7A7C87]">
                        Relationship
                      </p>
                      <p className="mt-1 text-sm font-normal text-[#353535]">
                        {data?.relationship}
                      </p>
                    </div>
                    <div className="col-span-1 px-8 py-4">
                      <p className="text-[10px] font-normal text-[#7A7C87]">
                        Phone Number
                      </p>
                      <p className="mt-1 text-sm font-normal text-[#353535]">
                        {data?.phoneNumber}
                      </p>
                    </div>
                    <div className="col-span-1 px-8 py-4">
                      <p className="text-[10px] font-normal text-[#7A7C87]">
                        Email address
                      </p>
                      <p className="mt-1 text-sm font-normal text-[#353535]">
                        {data?.emailAddress}
                      </p>
                    </div>
                    <div className="col-span-1 px-8 py-4">
                      <p className="text-[10px] font-normal text-[#7A7C87]">
                        Home Address
                      </p>
                      <p className="mt-1 text-sm font-normal text-[#353535]">
                        {data?.address}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-4 gap-x-16 px-6">
                  <div className="col-span-1 px-8 py-4">
                    <Button
                      variant="outline"
                      size="md"
                      className="w-[15rem] rounded border border-[#FF7A00] bg-[#FFF8F2] p-[0.1rem] text-[#FF7A00]"
                      label="Edit Guardian"
                      icon={<Icon name={Icons.Edit} />}
                      onClick={() => {
                        setUserId(data?.id);
                        setShowEditModal(true);
                      }}
                    ></Button>
                  </div>
                </div>
              </div>
            </div>

            <div className="my-3">
              <p className="text-base text-[#7A7C87]">Assigned Dependants</p>
              {!data?.isAssigned ? (
                <div className="mt-10">
                  <p className="text-center font-circular text-lg font-bold">
                    No children assigned
                  </p>
                </div>
              ) : (
                <div className="mt-2 h-[550px] overflow-auto rounded-md bg-white p-5 scrollbar-hide">
                  {data.children.map(children => (
                    <DependantDetails child={children} key={children.id} />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {showEditModal && userId && (
        <EditGuardianModal
          onClose={() => {
            setShowEditModal(false);
            refetch();
          }}
          onSuccess={() => {
            refetch();
            setShowEditModal(false);
            setUserId(null);
          }}
          guardianId={userId}
        />
      )}
    </div>
  );
}
